/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/split.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Split a single valued string into multiple strings.',
  examples: [
    'ROW words="foo;bar;baz;qux;quux;corge"\n| EVAL word = SPLIT(words, ";")',
  ],
  params: {
    string: 'String expression. If `null`, the function returns `null`.',
    delim: 'Delimiter. Only single byte delimiters are currently supported.',
  },
};

export default docs;
